import { makeRequest } from 'utils/requestLogger';

export default (turnID, payload) =>
  makeRequest('post', `/api/turns/${turnID}/give_feedback`, payload);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/sendFeedback.js